// Resalta en el texto los términos que el vendedor tecleó. Sin esto, con 40 SKUs filtrados a 6, el
// ojo tiene que releer cada tarjeta para entender POR QUÉ quedó en la lista.
//
// Presentacional puro: los rangos los calcula `rangosDeCoincidencia` (testeado aparte).
import { Fragment } from 'react';
import { rangosDeCoincidencia } from '../catalogFilters';

export function HighlightedText({ text, terms }: { text: string; terms: string[] }) {
    const rangos = rangosDeCoincidencia(text, terms);
    if (rangos.length === 0) return <>{text}</>;

    const piezas: { texto: string; marcado: boolean }[] = [];
    let cursor = 0;
    for (const [ini, fin] of rangos) {
        if (ini > cursor) piezas.push({ texto: text.slice(cursor, ini), marcado: false });
        piezas.push({ texto: text.slice(ini, fin), marcado: true });
        cursor = fin;
    }
    if (cursor < text.length) piezas.push({ texto: text.slice(cursor), marcado: false });

    return (
        <>
            {piezas.map((p, i) => (
                <Fragment key={`${String(i)}-${p.texto}`}>
                    {p.marcado ? (
                        <mark className="rounded-[2px] bg-primary/15 px-px text-inherit">
                            {p.texto}
                        </mark>
                    ) : (
                        p.texto
                    )}
                </Fragment>
            ))}
        </>
    );
}
